import React from 'react'
import context from '@/context'
import { ValidationBoundary } from '@/components/validation'
import { ModalBody, Row } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { ValidDates } from '@/components/changeRequests/common/validDates'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'

function CourseDialog (props) {
  return (
    <FormLoader {...props} render={() =>
      <ValidationBoundary>
        <BasicHeader title='Individuals.Course' {...props} />
        <ModalBody>
          <Row>
            <div className='col-12'>
              <FormRow label='Common.Type' name='courseType' inputType='lookup' dataSource={context.cache.getCourseTypes} clientSide isCodeList required />
              <FormRow label='Common.Description' name='description' inputType='textarea' required />
              <ValidDates fromName='dateFrom' toName='dateTo' fromKey='Individuals.DateFrom' toKey='Individuals.DateTo' />
            </div>
          </Row>
        </ModalBody>
        <ChangeItemDialogFooter {...props} />
      </ValidationBoundary>
    } />
  )
}

export default {
  component: CourseDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/course.js